<template>
  <div class="w100 app-card">
    <div class="po-r w100 bg-w app-card-main" v-loading="loading">
      <img class="po-a app-card-img" :src="data.serveImage ? data.serveImage : `${baseUrl}images/icon-app.png`" width="48" height="48">
      <p class="w100 ellipsis font-14 mb5">{{ data.serveName }}</p>
      <div class="w100 flex-box grey pb10 bor-b font-12">
        <span class="">{{ data.serveType | serveType }}</span>
        <span class="ml5 mr5">|</span>
        <span class="flex-1 ellipsis">{{ data.serveTitle }}</span>
      </div>
      <div class="mt5 flex-box al-c pr5">
        <div class="flex-1">
          <i v-for="i in 5" :key="i" :class="i <= data.appraise ? 'el-icon-star-on yellow' : 'el-icon-star-on grey2'"></i>
        </div>
        <!-- <div class="flex-box al-c" v-if="userToken">
          <i class="el-icon-star-on yellow font-16" v-show="data.collection"></i>
          <i class="el-icon-star-off grey" v-show="!data.collection"></i>
          <span class="font-12 grey hover">{{ data.collection ? '已收藏' : '未收藏' }}</span>
        </div> -->
        <span class="flex-1 tx-r ml10 grey font-12">{{ data.favoriteCount }}人收藏</span>
      </div>
      <div class="po-a flex-box flex-col ju-c al-c cu-p app-card-model" @click="clickItem">
        <p class="w100 font-16 mb10 white pl20 pr20 ellipsis">{{ data.serveName }}</p>
        <el-button class="w50" round size="mini" v-if="userToken" @click.stop="changeCollect">{{ data.collection ? '取消收藏' : '立即收藏' }}</el-button>
      </div>
    </div>
    <a ref="url" class="none" :href="url" target="_blank"></a>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "AppCard",
  components: {},
  props: {
    data: {
      type: Object,
    },
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      url: "",
    };
  },
  computed: {
    ...mapGetters(["userToken"]),
  },
  created() {},
  mounted() {},
  destroyed() {},
  methods: {
    changeCollect() {
      if (this.data.collection) {
        this.$http
          .delete("/personal/collection/delCo", {
            params: {
              serveId: this.data.id,
            },
          })
          .then(({ data }) => {
            if (data.resCode == 0) {
              this.$message.success(data.resMsg);
              this.data.collection = !this.data.collection;
              this.data.favoriteCount--;
              this.$emit("change-collect");
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      } else {
        this.$http
          .post(
            "/personal/collection/newCo",
            this.$qs.stringify({ serveId: this.data.id })
          )
          .then(({ data }) => {
            if (data.resCode == 0) {
              this.$message.success(data.resMsg);
              this.data.collection = !this.data.collection;
              this.data.favoriteCount++;
              this.$emit("change-collect");
            }
            this.loading = false;
          })
          .catch(() => {
            this.loading = false;
          });
      }
    },
    clickItem() {
      switch (this.data.serveType) {
        case 0:
          this.$router.push({
            path: `/serveSearch/${this.data.id}/${this.data.interfaceUrl}`,
          });
          break;
        case 1:
          this.$router.push({
            path: `/serveApproval/${this.data.id}`,
          });
          break;
        case 2:
          this.$router.push({
            path: `/serveCustomized/${this.data.id}/${this.data.interfaceUrl}`,
          });
          break;
        case 9:
          this.$http
            .post(
              "/statistical/serverInsert",
              this.$qs.stringify({
                serviceId: this.data.id,
                appType: 9,
              })
            )
            .then(() => {})
            .catch(() => {});

          this.url = this.data.linkUrl;
          this.$refs.url.click();
          break;
        default:
          break;
      }
    },
  },
  watch: {},
  filters: {
    serveType(value) {
      switch (value) {
        case 0:
          return "查询类";
        case 1:
          return "审批类";
        case 9:
          return "外部连接";
        default:
          break;
      }
    },
  },
};
</script>

<style scoped>
.app-card {
  padding: 0 0 0 24px;
}

.app-card-main {
  padding: 12px 10px 10px 36px;
  height: 100px;
  border: 1px solid #eee;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
}

.app-card-main:hover {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
}

.app-card-img {
  top: 26px;
  left: -24px;
  border: 1px solid #fff;
  border-radius: 50%;
  z-index: 2;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  background-color: #fff;
}

.app-card-model {
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: -webkit-linear-gradient(
    left,
    rgba(1, 140, 215, 0.9),
    rgba(44, 172, 240, 0.7)
  );
  background: -o-linear-gradient(
    left,
    rgba(1, 140, 215, 0.9),
    rgba(44, 172, 240, 0.7)
  );
  background: -moz-linear-gradient(
    left,
    rgba(1, 140, 215, 0.9),
    rgba(44, 172, 240, 0.7)
  );
  background: linear-gradient(
    left,
    rgba(1, 140, 215, 0.9),
    rgba(44, 172, 240, 0.7)
  );
  opacity: 0;
  border-radius: 4px;
}

.app-card-main:hover .app-card-model {
  opacity: 1;
}

.grey2 {
  color: #ddd;
}
</style>
